import {
  AlertCircle,
  BarChart3,
  Calculator,
  CheckCircle,
  DollarSign,
  Download,
  Home,
  Search,
  Settings,
  TrendingUp,
  Users,
} from "lucide-react";
import { useCallback, useEffect, useMemo, useState } from "react";

const SistemaClassificacao = () => {
  const [activeSection, setActiveSection] = useState("despesas");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("");

  const [itensRateio, setItensRateio] = useState([]);
  const [, setLoadingItensRateio] = useState(false);
  const [tiposRateio, setTiposRateio] = useState([]);

  const [Rateio, setRateio] = useState([]);
  const [valores, setvaloreso] = useState([]);

  const [despesasData, setDespesasData] = useState([]);
  const [investimentosData, setinvestimentosData] = useState([]);
  const [rhData, setrhData] = useState([]);
  const [receitasData, setreceitasData] = useState([]);

  const [ReceitaDivData, setReceitaDivData] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_URL;

  // ✅ FUNÇÃO PARA CARREGAR ITENS DE RATEIO DO BANCO
  const carregarItensRateio = useCallback(
    async (centroCusto, codTipoRateio) => {
      try {
        setLoadingItensRateio(true);
        const token = localStorage.getItem("authToken");
        if (!token) return;

        const PCODCOLIGADA = localStorage.getItem("PCODCOLIGADA");
        const PCODFILIAL = localStorage.getItem("PCODFILIAL");

        // Monta a cláusula WHERE básica
        let whereClause =
          `AND CODCOLIGADA = '${PCODCOLIGADA}' ` +
          `AND CODFILIAL   = '${PCODFILIAL}' ` +
          `AND ANO         = '${localStorage.getItem(
            "selectedYear"
          )}' AND VALOR > 0`;

        console.log("🔍 Carregando itens de rateio com WHERE:", whereClause);

        const response = await fetch(
          `${API_BASE_URL}/totvs-sql/sql_Man_Orc_MQ/filter`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              WHERE: whereClause,
              ORDER_BY: "IDRATEIO DESC",
            }),
          }
        );

        const result = await response.json();
        console.log("📋 Resultado dos itens de rateio:", result);

        if (result.success && result.data) {
          const itensMapeados = result.data.map((item) => ({
            id: item.IDRATEIO,
            codColigada: item.CODCOLIGADA,
            codFilial: item.CODFILIAL,
            centroCusto: item.CODCCUSTO,
            nomecusto: item.CENTROCUSTO,
            ano: item.ANO,

            rateio: item.RATEIO,
            valores: item.VALORES,

            descrateio: item.DESRATEIO,
            descvalores: item.DESVALORES,

            valor: parseFloat(item.VALOR),
            codTipoRateio: item.CODTIPORAT,
            tipoRateioDesc: item.TIPORATEIRO,
            tipo: item.TIPO,
          }));

          console.log("✅ Itens de rateio mapeados:", itensMapeados);
          setItensRateio(itensMapeados);

          // monta o lookup de tipos únicos
          const mapTipos = itensMapeados.reduce((acc, item) => {
            acc[item.codTipoRateio] = item.tipoRateioDesc;
            return acc;
          }, {});

          // monta o lookup de rateio (CÓDIGO → DESCRIÇÃO)
          const mapRateio = itensMapeados.reduce((acc, item) => {
            if (item.rateio && item.descrateio) {
              acc[item.rateio] = item.descrateio;
            }
            return acc;
          }, {});

          // monta o lookup de valores (CÓDIGO → DESCRIÇÃO)
          const mapValores = itensMapeados.reduce((acc, item) => {
            if (item.valores && item.descvalores) {
              acc[item.valores] = item.descvalores;
            }
            return acc;
          }, {});

          // converte para array e adiciona cor se quiser
          const corPorTipo = {
            20: "secondary",
            21: "primary",
            22: "warning",
            23: "info",
            24: "success",
            25: "danger",
            26: "dark",
            30: "secondary",
            31: "primary",
            32: "warning",
            33: "info",
            34: "success",
            35: "danger",
            36: "dark",
          };

          const tipos = Object.entries(mapTipos).map(([value, label]) => ({
            value,
            label,
            color: corPorTipo[value] || "secondary",
          }));

          const rateio = Object.entries(mapRateio).map(([value, label]) => ({
            value,
            label,
          }));

          const valoress = Object.entries(mapValores).map(([value, label]) => ({
            value,
            label,
          }));

          setTiposRateio(tipos);
          setRateio(rateio);
          setvaloreso(valoress);
        } else {
          console.log("⚠️ Nenhum item de rateio encontrado");
          setItensRateio([]);
        }
      } catch (error) {
        console.error("❌ Erro ao carregar itens de rateio:", error);
        setItensRateio([]);
        setRateio([]);
        setvaloreso([]);
      } finally {
        setLoadingItensRateio(false);
      }
    },
    [] // adicione dependências se precisar refazer em função de variáveis externas
  );

  // useEffect para carregar dados iniciais
  useEffect(() => {
    carregarItensRateio();
  }, []);

  // atualiza despesasData sempre que itensRateio mudar
  useEffect(() => {
    if (!itensRateio.length) return;

    const despesas = itensRateio
      .filter((item) => item.tipo === "Despesas")
      .map((item) => ({
        id: item.id, // IDRATEIO
        filial: item.codFilial, // CODFILIAL
        tipoCusto: item.tipo, // TIPO
        codigo: item.centroCusto, // CODCCUSTO
        centroCusto: item.nomecusto, // (ou DESCRICAOCCUSTO, se tiver)
        vlrLiquido: item.valor, // VALOR
        tipoRateio: item.codTipoRateio, // TIPORATEIRO
        status: "configured",
      }));

    setDespesasData(despesas);

    const receitaDiversas = itensRateio
      .filter((item) => item.tipo === "Rec.Diversas")
      .map((item) => ({
        id: item.id, // IDRATEIO
        filial: item.codFilial, // CODFILIAL
        tipoCusto: item.tipo, // TIPO
        codigo: item.centroCusto, // CODCCUSTO
        centroCusto: item.nomecusto, // (ou DESCRICAOCCUSTO, se tiver)
        vlrLiquido: item.valor, // VALOR
        tipoRateio: item.codTipoRateio, // TIPORATEIRO
        status: "configured",
      }));

    setReceitaDivData(receitaDiversas);

    const investimentosData = itensRateio
      .filter((item) => item.tipo === "Investimento")
      .map((item) => ({
        id: item.id, // IDRATEIO
        filial: item.codFilial, // CODFILIAL
        tipoCusto: item.tipo, // TIPO
        codigo: item.centroCusto, // CODCCUSTO
        centroCusto: item.nomecusto, // (ou DESCRICAOCCUSTO, se tiver)
        vlrLiquido: item.valor, // VALOR
        tipoRateio: item.codTipoRateio, // TIPORATEIRO
        status: "configured",
      }));

    setinvestimentosData(investimentosData);

    const rhData = itensRateio
      .filter((item) => item.tipo === "RH")
      .map((item) => ({
        id: item.id, // IDRATEIO
        filial: item.codFilial, // CODFILIAL
        tipoCusto: item.tipo, // TIPO
        codigo: item.centroCusto, // CODCCUSTO
        centroCusto: item.nomecusto, // (ou DESCRICAOCCUSTO, se tiver)
        vlrLiquido: item.valor, // VALOR
        tipoRateio: item.codTipoRateio, // TIPORATEIRO
        status: "configured",
      }));

    setrhData(rhData);

    const receitasData = itensRateio
      .filter((item) => item.tipo === "EDU")
      .map((item) => ({
        id: item.id, // IDRATEIO
        filial: item.codFilial, // CODFILIAL
        tipoCusto: item.tipo, // TIPO
        codigo: item.centroCusto, // CODCCUSTO
        centroCusto: item.nomecusto, // (ou DESCRICAOCCUSTO, se tiver)
        vlrLiquido: item.valor, // VALOR
        tipoRateio: item.codTipoRateio, // TIPORATEIRO
        rateio: item.rateio,
        descrateio: item.descrateio,
        valores: item.valores,
        descvalores: item.descvalores,

        status: "configured",
        cebas: 0.0,
        vlrBruto: 0.0,
        resultado: 0.0,
      }));

    setreceitasData(receitasData);
  }, [itensRateio]);

  const menuItems = [
    { id: "dashboard", titulo: "Dashboard", icon: Home },
    { id: "despesas", titulo: "Despesas", icon: DollarSign },
    { id: "investimentos", titulo: "Investimentos", icon: BarChart3 },
    { id: "rh", titulo: "Recursos Humanos", icon: Users },
    { id: "ReceitaDiversas", titulo: "Rec. Diversas", icon: TrendingUp },
    { id: "receitas", titulo: "Rec. Educacionais", icon: TrendingUp },
    { id: "resultado", titulo: "Resultado", icon: Calculator },
  ];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "configured":
        return <CheckCircle size={16} className="text-success" />;
      case "pending":
        return <AlertCircle size={16} className="text-warning" />;
      default:
        return <AlertCircle size={16} className="text-secondary" />;
    }
  };

  // Filtrar dados de despesas - ADICIONAR AQUI
  const filteredDespesasData = useMemo(() => {
    console.log("🔍 APLICANDO FILTRO:");
    console.log("filterType:", filterType, "searchTerm:", searchTerm);

    const filtered = despesasData.filter((item) => {
      // Filtro por tipo de rateio
      const typeMatch =
        filterType === "TODOS" ||
        filterType === "" ||
        String(item.tipoRateio) === String(filterType);

      // Filtro por busca (centro de custo ou código)
      const searchMatch =
        searchTerm === "" ||
        item.centroCusto.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.codigo.toLowerCase().includes(searchTerm.toLowerCase());

      const shouldShow = typeMatch && searchMatch;

      if (filterType !== "TODOS" && filterType !== "") {
        console.log(
          `Item ${item.centroCusto}: tipoRateio=${item.tipoRateio}, typeMatch=${typeMatch}, shouldShow=${shouldShow}`
        );
      }

      return shouldShow;
    });

    console.log(
      `✅ Filtrados: ${filtered.length} de ${despesasData.length} itens`
    );
    return filtered;
  }, [despesasData, filterType, searchTerm]);

  // Filtrar dados de despesas - ADICIONAR AQUI
  const filteredReceitaDivData = useMemo(() => {
    console.log("🔍 APLICANDO FILTRO:");
    console.log("filterType:", filterType, "searchTerm:", searchTerm);

    const filtered = ReceitaDivData.filter((item) => {
      // Filtro por tipo de rateio
      const typeMatch =
        filterType === "TODOS" ||
        filterType === "" ||
        String(item.tipoRateio) === String(filterType);

      // Filtro por busca (centro de custo ou código)
      const searchMatch =
        searchTerm === "" ||
        item.centroCusto.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.codigo.toLowerCase().includes(searchTerm.toLowerCase());

      const shouldShow = typeMatch && searchMatch;

      if (filterType !== "TODOS" && filterType !== "") {
        console.log(
          `Item ${item.centroCusto}: tipoRateio=${item.tipoRateio}, typeMatch=${typeMatch}, shouldShow=${shouldShow}`
        );
      }

      return shouldShow;
    });

    console.log(
      `✅ Filtrados: ${filtered.length} de ${ReceitaDivData.length} itens`
    );
    return filtered;
  }, [ReceitaDivData, filterType, searchTerm]);

  // Filtrar dados de despesas - ADICIONAR AQUI
  const filteredInvestimentoData = useMemo(() => {
    console.log("🔍 APLICANDO FILTRO:");
    console.log("filterType:", filterType, "searchTerm:", searchTerm);

    const filtered = investimentosData.filter((item) => {
      // Filtro por tipo de rateio
      const typeMatch =
        filterType === "TODOS" ||
        filterType === "" ||
        String(item.tipoRateio) === String(filterType);

      // Filtro por busca (centro de custo ou código)
      const searchMatch =
        searchTerm === "" ||
        item.centroCusto.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.codigo.toLowerCase().includes(searchTerm.toLowerCase());

      const shouldShow = typeMatch && searchMatch;

      if (filterType !== "TODOS" && filterType !== "") {
        console.log(
          `Item ${item.centroCusto}: tipoRateio=${item.tipoRateio}, typeMatch=${typeMatch}, shouldShow=${shouldShow}`
        );
      }

      return shouldShow;
    });

    console.log(
      `✅ Filtrados: ${filtered.length} de ${investimentosData.length} itens`
    );
    return filtered;
  }, [investimentosData, filterType, searchTerm]);

  // Filtrar dados de despesas - ADICIONAR AQUI
  const filteredRHData = useMemo(() => {
    console.log("🔍 APLICANDO FILTRO:");
    console.log("filterType:", filterType, "searchTerm:", searchTerm);

    const filtered = rhData.filter((item) => {
      // Filtro por tipo de rateio
      const typeMatch =
        filterType === "TODOS" ||
        filterType === "" ||
        String(item.tipoRateio) === String(filterType);

      // Filtro por busca (centro de custo ou código)
      const searchMatch =
        searchTerm === "" ||
        item.centroCusto.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.codigo.toLowerCase().includes(searchTerm.toLowerCase());

      const shouldShow = typeMatch && searchMatch;

      if (filterType !== "TODOS" && filterType !== "") {
        console.log(
          `Item ${item.centroCusto}: tipoRateio=${item.tipoRateio}, typeMatch=${typeMatch}, shouldShow=${shouldShow}`
        );
      }

      return shouldShow;
    });

    console.log(
      `✅ Filtrados: ${filtered.length} de ${rhData.length} itens`
    );
    return filtered;
  }, [rhData, filterType, searchTerm]);

  // ✅ SUBSTITUA SEU filteredEduData POR ESTE CORRIGIDO:
  const filteredEduData = useMemo(() => {
    console.log("🔍 APLICANDO FILTRO EDU:");
    console.log("filterType:", filterType, "searchTerm:", searchTerm);
    console.log("receitasData total:", receitasData.length); // ✅ Debug adicional

    const filtered = receitasData.filter((item) => {
      // Filtro por tipo de rateio
      const typeMatch =
        filterType === "TODOS" ||
        filterType === "" ||
        String(item.tipoRateio) === String(filterType);

      // Filtro por busca (centro de custo ou código)
      const searchMatch =
        searchTerm === "" ||
        item.centroCusto.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.codigo.toLowerCase().includes(searchTerm.toLowerCase());

      const shouldShow = typeMatch && searchMatch;

      // ✅ Só logga quando realmente há filtros aplicados para reduzir spam
      if ((filterType !== "TODOS" && filterType !== "") || searchTerm !== "") {
        console.log(
          `Item ${item.centroCusto}: tipoRateio=${item.tipoRateio}, typeMatch=${typeMatch}, searchMatch=${searchMatch}, shouldShow=${shouldShow}`
        );
      }

      return shouldShow;
    });

    console.log(
      `✅ Filtrados EDU: ${filtered.length} de ${receitasData.length} itens` // ✅ CORREÇÃO PRINCIPAL!
    );
    return filtered;
  }, [receitasData, filterType, searchTerm]);

  // ✅ PASSO 2: Cole estas funções LOGO APÓS a linha acima:
  const calculateUniqueTotal = (data) => {
    const uniqueCenters = new Map();
    data.forEach((item) => {
      if (!uniqueCenters.has(item.centroCusto)) {
        uniqueCenters.set(item.centroCusto, item.vlrLiquido);
      }
    });
    return Array.from(uniqueCenters.values()).reduce(
      (sum, value) => sum + value,
      0
    );
  };

  const getUniqueCentersCount = (data) => {
    return new Set(data.map((item) => item.centroCusto)).size;
  };

  const getUniqueConfiguredCount = (data) => {
    const uniqueConfigured = new Map();
    data.forEach((item) => {
      if (
        !uniqueConfigured.has(item.centroCusto) &&
        item.status === "configured"
      ) {
        uniqueConfigured.set(item.centroCusto, true);
      }
    });
    return uniqueConfigured.size;
  };

  // ✅ FUNÇÃO PARA ATUALIZAR CAMPOS DO ORÇAMENTO
  const MaquinaRateioGeral = useCallback(
    async (CODCCUSTO, TIPOCUSTO, TIPORATEIO, CODFILIAL) => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          return { success: false, message: "Token não encontrado" };
        }

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        const dados = {
          CODCCUSTO: CODCCUSTO,
          CODFILIAL: CODFILIAL,
          TIPOCUSTO: TIPOCUSTO,
          TIPORATEIO: TIPORATEIO,
          CODCOLIGADA: localStorage.getItem("PCODCOLIGADA"),
          ANO: localStorage.getItem("selectedYear"),
        };

        console.log("💾 Salvando campo do orçamento:", dados);

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/SQlCustom/MaquinaRateioGeral`,
          {
            method: "POST",
            headers,
            body: JSON.stringify(dados),
          }
        );

        const result = await response.json();

        if (response.ok) {
          console.log("✅ Campo do orçamento atualizado com sucesso");
          return { success: true, data: result };
        } else {
          console.error("❌ Erro ao atualizar campo do orçamento:", result);
          return {
            success: false,
            message: result.error || "Erro desconhecido",
          };
        }
      } catch (error) {
        console.error("❌ Erro na requisição de atualização:", error);
        return { success: false, message: error.message };
      }
    },
    []
  );

  // ✅ FUNÇÃO PARA ATUALIZAR CAMPOS DO ORÇAMENTO
  const MaquinaRateiRH = useCallback(
    async (CODCCUSTO, TIPORATEIO, CODFILIAL) => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          return { success: false, message: "Token não encontrado" };
        }

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        const dados = {
          CODCCUSTO: CODCCUSTO,
          CODFILIAL: CODFILIAL,
          TIPORATEIO: TIPORATEIO,
          CODCOLIGADA: localStorage.getItem("PCODCOLIGADA"),
          ANO: localStorage.getItem("selectedYear"),
        };

        console.log("💾 Salvando campo do orçamento:", dados);

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/SQlCustom/MaquinaRateiRH`,
          {
            method: "POST",
            headers,
            body: JSON.stringify(dados),
          }
        );

        const result = await response.json();

        if (response.ok) {
          console.log("✅ Campo do orçamento atualizado com sucesso");
          return { success: true, data: result };
        } else {
          console.error("❌ Erro ao atualizar campo do orçamento:", result);
          return {
            success: false,
            message: result.error || "Erro desconhecido",
          };
        }
      } catch (error) {
        console.error("❌ Erro na requisição de atualização:", error);
        return { success: false, message: error.message };
      }
    },
    []
  );

  // ✅ FUNÇÃO PARA ATUALIZAR CAMPOS DO ORÇAMENTO
  const MaquinaRateioEDU = useCallback(
    async (CODCCUSTO, TIPORATEIO, RATEIO, RATEIOVALOR, CODFILIAL) => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          return { success: false, message: "Token não encontrado" };
        }

        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        const dados = {
          CODCOLIGADA: localStorage.getItem("PCODCOLIGADA"),
          CODFILIAL: CODFILIAL,
          CODCCUSTO: CODCCUSTO,
          TIPORATEIO: TIPORATEIO,
          RATEIO: RATEIO,
          RATEIOVALOR: RATEIOVALOR,
          ANO: localStorage.getItem("selectedYear"),
        };

        console.log("💾 Salvando campo do orçamento:", dados);

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/SQlCustom/MaquinaRateioEDU`,
          {
            method: "POST",
            headers,
            body: JSON.stringify(dados),
          }
        );

        const result = await response.json();

        if (response.ok) {
          console.log("✅ Campo do orçamento atualizado com sucesso");
          return { success: true, data: result };
        } else {
          console.error("❌ Erro ao atualizar campo do orçamento:", result);
          return {
            success: false,
            message: result.error || "Erro desconhecido",
          };
        }
      } catch (error) {
        console.error("❌ Erro na requisição de atualização:", error);
        return { success: false, message: error.message };
      }
    },
    []
  );

  // ✅ PASSO 4: Sua função renderDespesas deve ficar assim:
  const renderDespesas = () => {
    // Calcular valores baseados nos dados filtrados
    const filteredTotal = filteredDespesasData.reduce(
      (sum, item) => sum + item.vlrLiquido,
      0
    );

    return (
      <div className="container-fluid">
        {/* Header com métricas */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center">
                      <div className="p-3 bg-danger bg-opacity-10 rounded-3 me-3">
                        <DollarSign className="text-danger" size={24} />
                      </div>
                      <div>
                        <h4 className="fw-bold mb-1 text-danger">
                          RATEIO DE DESPESAS
                        </h4>
                        <p className="text-muted mb-0">
                          Classificação de centros de custo
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 text-md-end">
                    <div className="row g-3">
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">
                            Total{" "}
                            {filterType !== "TODOS" && filterType !== ""
                              ? "Filtrado"
                              : "Geral"}
                          </small>
                          <h5 className="fw-bold mb-0">
                            {formatCurrency(filteredTotal)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">Itens</small>
                          <h5 className="fw-bold mb-0">
                            {filteredDespesasData.length}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row g-3 align-items-center">
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">
                      Tipo de Rateio
                    </label>
                    <select
                      className="form-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="TODOS">TODOS</option>
                      {tiposRateio.map((tipo, index) => (
                        <option
                          key={`filter-${tipo.value}-${index}`}
                          value={tipo.value}
                        >
                          {tipo.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Buscar</label>
                    <div className="position-relative">
                      <Search
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                        size={16}
                      />
                      <input
                        type="text"
                        placeholder="Centro de custo ou código..."
                        className="form-control ps-5"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabela de classificação */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-0 p-4">
                <h5 className="fw-semibold mb-0">
                  Classificação de Centros de Custo
                  {(filterType !== "TODOS" && filterType !== "") ||
                  searchTerm !== "" ? (
                    <span className="text-muted fs-6 ms-2">
                      ({filteredDespesasData.length} de {despesasData.length}{" "}
                      itens)
                    </span>
                  ) : null}
                </h5>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="border-0 py-3">Status</th>
                        <th className="border-0 py-3">Filial</th>
                        <th className="border-0 py-3">Código</th>
                        <th className="border-0 py-3">Centro de Custo</th>
                        <th className="border-0 py-3">Valor Líquido</th>
                        <th className="border-0 py-3">Tipo de Rateio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredDespesasData.length > 0 ? (
                        filteredDespesasData.map((item, index) => {
                          const tipoRateioObj = tiposRateio.find(
                            (t) => String(t.value) === String(item.tipoRateio)
                          );
                          return (
                            <tr
                              key={`despesa-${item.id || index}`}
                              className="align-middle"
                            >
                              <td className="px-4">
                                {getStatusIcon(item.status)}
                              </td>
                              <td className="px-4">
                                <span className="badge bg-light text-dark">
                                  {item.filial}
                                </span>
                              </td>
                              <td className="px-4">
                                <code className="bg-light px-2 py-1 rounded">
                                  {item.codigo}
                                </code>
                              </td>
                              <td className="px-4">
                                <div>
                                  <span className="fw-semibold">
                                    {item.centroCusto}
                                  </span>
                                  <br />
                                  <small className="text-muted">
                                    {item.tipoCusto}
                                  </small>
                                </div>
                              </td>
                              <td className="px-4">
                                <span className="fw-bold text-primary">
                                  {formatCurrency(item.vlrLiquido)}
                                </span>
                              </td>
                              <td className="px-4">
                                <select
                                  className="form-select form-select-sm"
                                  value={item.tipoRateio}
                                  onChange={async (e) => {
                                    const newTipoRateio = e.target.value;
                                    console.log(
                                      `🔄 DESPESAS: Alterando item ${item.centroCusto} para tipo ${newTipoRateio}`
                                    );

                                    const updatedData = despesasData.map(
                                      (despesa) =>
                                        despesa.centroCusto === item.centroCusto
                                          ? {
                                              ...despesa,
                                              tipoRateio: newTipoRateio,
                                            }
                                          : despesa
                                    );
                                    setDespesasData(updatedData);

                                    try {
                                      const resultado =
                                        await MaquinaRateioGeral(
                                          item.codigo,
                                          "1",
                                          newTipoRateio,
                                          item.filial
                                        );
                                      if (resultado.success) {
                                        console.log(
                                          "✅ DESPESAS: Tipo rateio salvo com sucesso"
                                        );
                                      } else {
                                        console.error(
                                          "❌ DESPESAS: Erro ao salvar:",
                                          resultado.message
                                        );
                                      }
                                    } catch (error) {
                                      console.error(
                                        "❌ DESPESAS: Erro na chamada da API:",
                                        error
                                      );
                                    }
                                  }}
                                >
                                  {tiposRateio.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>
                                      {tipo.label}
                                    </option>
                                  ))}
                                </select>
                                {tipoRateioObj && (
                                  <div className="mt-1">
                                    <span
                                      className={`badge bg-${
                                        tipoRateioObj.color || "secondary"
                                      } bg-opacity-10 text-${
                                        tipoRateioObj.color || "secondary"
                                      } small`}
                                    >
                                      {tipoRateioObj.label}
                                    </span>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center py-4 text-muted"
                          >
                            <div className="d-flex flex-column align-items-center">
                              <AlertCircle
                                size={48}
                                className="text-muted mb-2"
                              />
                              <p className="mb-0">
                                Nenhum item encontrado com os filtros aplicados
                              </p>
                              <small>Tente alterar os critérios de busca</small>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderInvestimentos = () => {
    // Calcular valores baseados nos dados filtrados
    const filteredTotal = filteredInvestimentoData.reduce(
      (sum, item) => sum + item.vlrLiquido,
      0
    );

    return (
      <div className="container-fluid">
        {/* Header com métricas */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center">
                      <div className="p-3 bg-danger bg-opacity-10 rounded-3 me-3">
                        <BarChart3 className="text-primary" size={24} />
                      </div>
                      <div>
                        <h4 className="fw-bold mb-1 text-primary">
                          RATEIO DE INVESTIMENTOS
                        </h4>
                        <p className="text-muted mb-0">
                          Classificação de centros de custo
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 text-md-end">
                    <div className="row g-3">
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">
                            Total{" "}
                            {filterType !== "TODOS" && filterType !== ""
                              ? "Filtrado"
                              : "Geral"}
                          </small>
                          <h5 className="fw-bold mb-0">
                            {formatCurrency(filteredTotal)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">Itens</small>
                          <h5 className="fw-bold mb-0">
                            {filteredInvestimentoData.length}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row g-3 align-items-center">
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">
                      Tipo de Rateio
                    </label>
                    <select
                      className="form-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="TODOS">TODOS</option>
                      {tiposRateio.map((tipo, index) => (
                        <option
                          key={`filter-${tipo.value}-${index}`}
                          value={tipo.value}
                        >
                          {tipo.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Buscar</label>
                    <div className="position-relative">
                      <Search
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                        size={16}
                      />
                      <input
                        type="text"
                        placeholder="Centro de custo ou código..."
                        className="form-control ps-5"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabela de classificação */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-0 p-4">
                <h5 className="fw-semibold mb-0">
                  Classificação de Centros de Custo
                  {(filterType !== "TODOS" && filterType !== "") ||
                  searchTerm !== "" ? (
                    <span className="text-muted fs-6 ms-2">
                      ({filteredInvestimentoData.length} de{" "}
                      {investimentosData.length} itens)
                    </span>
                  ) : null}
                </h5>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="border-0 py-3">Status</th>
                        <th className="border-0 py-3">Filial</th>
                        <th className="border-0 py-3">Código</th>
                        <th className="border-0 py-3">Centro de Custo</th>
                        <th className="border-0 py-3">Valor Líquido</th>
                        <th className="border-0 py-3">Tipo de Rateio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredInvestimentoData.length > 0 ? (
                        filteredInvestimentoData.map((item, index) => {
                          const tipoRateioObj = tiposRateio.find(
                            (t) => String(t.value) === String(item.tipoRateio)
                          );
                          return (
                            <tr
                              key={`despesa-${item.id || index}`}
                              className="align-middle"
                            >
                              <td className="px-4">
                                {getStatusIcon(item.status)}
                              </td>
                              <td className="px-4">
                                <span className="badge bg-light text-dark">
                                  {item.filial}
                                </span>
                              </td>
                              <td className="px-4">
                                <code className="bg-light px-2 py-1 rounded">
                                  {item.codigo}
                                </code>
                              </td>
                              <td className="px-4">
                                <div>
                                  <span className="fw-semibold">
                                    {item.centroCusto}
                                  </span>
                                  <br />
                                  <small className="text-muted">
                                    {item.tipoCusto}
                                  </small>
                                </div>
                              </td>
                              <td className="px-4">
                                <span className="fw-bold text-primary">
                                  {formatCurrency(item.vlrLiquido)}
                                </span>
                              </td>
                              <td className="px-4">
                                <select
                                  className="form-select form-select-sm"
                                  value={item.tipoRateio}
                                  onChange={async (e) => {
                                    const newTipoRateio = e.target.value;
                                    console.log(
                                      `🔄 INVESTIMENTO: Alterando item ${item.centroCusto} para tipo ${newTipoRateio}`
                                    );

                                    const updatedData = investimentosData.map(
                                      (despesa) =>
                                        despesa.centroCusto === item.centroCusto
                                          ? {
                                              ...despesa,
                                              tipoRateio: newTipoRateio,
                                            }
                                          : despesa
                                    );
                                    setinvestimentosData(updatedData);

                                    try {
                                      const resultado =
                                        await MaquinaRateioGeral(
                                          item.codigo,
                                          "2",
                                          newTipoRateio,
                                          item.filial
                                        );
                                      if (resultado.success) {
                                        console.log(
                                          "✅ INVESTIMENTO: Tipo rateio salvo com sucesso"
                                        );
                                      } else {
                                        console.error(
                                          "❌ INVESTIMENTO: Erro ao salvar:",
                                          resultado.message
                                        );
                                      }
                                    } catch (error) {
                                      console.error(
                                        "❌ INVESTIMENTO: Erro na chamada da API:",
                                        error
                                      );
                                    }
                                  }}
                                >
                                  {tiposRateio.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>
                                      {tipo.label}
                                    </option>
                                  ))}
                                </select>
                                {tipoRateioObj && (
                                  <div className="mt-1">
                                    <span
                                      className={`badge bg-${
                                        tipoRateioObj.color || "secondary"
                                      } bg-opacity-10 text-${
                                        tipoRateioObj.color || "secondary"
                                      } small`}
                                    >
                                      {tipoRateioObj.label}
                                    </span>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center py-4 text-muted"
                          >
                            <div className="d-flex flex-column align-items-center">
                              <AlertCircle
                                size={48}
                                className="text-muted mb-2"
                              />
                              <p className="mb-0">
                                Nenhum item encontrado com os filtros aplicados
                              </p>
                              <small>Tente alterar os critérios de busca</small>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderReceitaDiversas = () => {
    // Calcular valores baseados nos dados filtrados
    const filteredTotal = filteredReceitaDivData.reduce(
      (sum, item) => sum + item.vlrLiquido,
      0
    );

    return (
      <div className="container-fluid">
        {/* Header com métricas */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center">
                      <div className="p-3 bg-danger bg-opacity-10 rounded-3 me-3">
                        <BarChart3 className="text-primary" size={24} />
                      </div>
                      <div>
                        <h4 className="fw-bold mb-1 text-primary">
                          RATEIO DE RECEITA DIVERSAS
                        </h4>
                        <p className="text-muted mb-0">
                          Classificação de centros de custo
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 text-md-end">
                    <div className="row g-3">
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">
                            Total{" "}
                            {filterType !== "TODOS" && filterType !== ""
                              ? "Filtrado"
                              : "Geral"}
                          </small>
                          <h5 className="fw-bold mb-0">
                            {formatCurrency(filteredTotal)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">Itens</small>
                          <h5 className="fw-bold mb-0">
                            {filteredReceitaDivData.length}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row g-3 align-items-center">
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">
                      Tipo de Rateio
                    </label>
                    <select
                      className="form-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="TODOS">TODOS</option>
                      {tiposRateio.map((tipo, index) => (
                        <option
                          key={`filter-${tipo.value}-${index}`}
                          value={tipo.value}
                        >
                          {tipo.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Buscar</label>
                    <div className="position-relative">
                      <Search
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                        size={16}
                      />
                      <input
                        type="text"
                        placeholder="Centro de custo ou código..."
                        className="form-control ps-5"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabela de classificação */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-0 p-4">
                <h5 className="fw-semibold mb-0">
                  Classificação de Centros de Custo
                  {(filterType !== "TODOS" && filterType !== "") ||
                  searchTerm !== "" ? (
                    <span className="text-muted fs-6 ms-2">
                      ({filteredReceitaDivData.length} de{" "}
                      {ReceitaDivData.length} itens)
                    </span>
                  ) : null}
                </h5>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="border-0 py-3">Status</th>
                        <th className="border-0 py-3">Filial</th>
                        <th className="border-0 py-3">Código</th>
                        <th className="border-0 py-3">Centro de Custo</th>
                        <th className="border-0 py-3">Valor Líquido</th>
                        <th className="border-0 py-3">Tipo de Rateio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredReceitaDivData.length > 0 ? (
                        filteredReceitaDivData.map((item, index) => {
                          const tipoRateioObj = tiposRateio.find(
                            (t) => String(t.value) === String(item.tipoRateio)
                          );
                          return (
                            <tr
                              key={`despesa-${item.id || index}`}
                              className="align-middle"
                            >
                              <td className="px-4">
                                {getStatusIcon(item.status)}
                              </td>
                              <td className="px-4">
                                <span className="badge bg-light text-dark">
                                  {item.filial}
                                </span>
                              </td>
                              <td className="px-4">
                                <code className="bg-light px-2 py-1 rounded">
                                  {item.codigo}
                                </code>
                              </td>
                              <td className="px-4">
                                <div>
                                  <span className="fw-semibold">
                                    {item.centroCusto}
                                  </span>
                                  <br />
                                  <small className="text-muted">
                                    {item.tipoCusto}
                                  </small>
                                </div>
                              </td>
                              <td className="px-4">
                                <span className="fw-bold text-primary">
                                  {formatCurrency(item.vlrLiquido)}
                                </span>
                              </td>
                              <td className="px-4">
                                <select
                                  className="form-select form-select-sm"
                                  value={item.tipoRateio}
                                  onChange={async (e) => {
                                    const newTipoRateio = e.target.value;
                                    console.log(
                                      `🔄 R.DIVERSAS: Alterando item ${item.centroCusto} para tipo ${newTipoRateio}`
                                    );

                                    const updatedData = ReceitaDivData.map(
                                      (despesa) =>
                                        despesa.centroCusto === item.centroCusto
                                          ? {
                                              ...despesa,
                                              tipoRateio: newTipoRateio,
                                            }
                                          : despesa
                                    );
                                    setReceitaDivData(updatedData);

                                    try {
                                      const resultado =
                                        await MaquinaRateioGeral(
                                          item.codigo,
                                          "3",
                                          newTipoRateio,
                                          item.filial
                                        );
                                      if (resultado.success) {
                                        console.log(
                                          "✅ R.DIVERSAS: Tipo rateio salvo com sucesso"
                                        );
                                      } else {
                                        console.error(
                                          "❌ R.DIVERSAS: Erro ao salvar:",
                                          resultado.message
                                        );
                                      }
                                    } catch (error) {
                                      console.error(
                                        "❌ R.DIVERSAS: Erro na chamada da API:",
                                        error
                                      );
                                    }
                                  }}
                                >
                                  {tiposRateio.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>
                                      {tipo.label}
                                    </option>
                                  ))}
                                </select>
                                {tipoRateioObj && (
                                  <div className="mt-1">
                                    <span
                                      className={`badge bg-${
                                        tipoRateioObj.color || "secondary"
                                      } bg-opacity-10 text-${
                                        tipoRateioObj.color || "secondary"
                                      } small`}
                                    >
                                      {tipoRateioObj.label}
                                    </span>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center py-4 text-muted"
                          >
                            <div className="d-flex flex-column align-items-center">
                              <AlertCircle
                                size={48}
                                className="text-muted mb-2"
                              />
                              <p className="mb-0">
                                Nenhum item encontrado com os filtros aplicados
                              </p>
                              <small>Tente alterar os critérios de busca</small>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderRH = () => {
    // Calcular valores baseados nos dados filtrados
    const filteredTotal = filteredRHData.reduce(
      (sum, item) => sum + item.vlrLiquido,
      0
    );

    return (
      <div className="container-fluid">
        {/* Header com métricas */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center">
                      <div className="p-3 bg-info bg-opacity-10 rounded-3 me-3">
                        <Users className="text-info" size={24} />
                      </div>
                      <div>
                        <h4 className="fw-bold mb-1 text-info">
                          RATEIO RECURSOS HUMANOS
                        </h4>
                        <p className="text-muted mb-0">
                          Classificação de centros de custo
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 text-md-end">
                    <div className="row g-3">
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">
                            Total{" "}
                            {filterType !== "TODOS" && filterType !== ""
                              ? "Filtrado"
                              : "Geral"}
                          </small>
                          <h5 className="fw-bold mb-0">
                            {formatCurrency(filteredTotal)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">Itens</small>
                          <h5 className="fw-bold mb-0">
                            {filteredRHData.length}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row g-3 align-items-center">
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">
                      Tipo de Rateio
                    </label>
                    <select
                      className="form-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="TODOS">TODOS</option>
                      {tiposRateio.map((tipo, index) => (
                        <option
                          key={`filter-${tipo.value}-${index}`}
                          value={tipo.value}
                        >
                          {tipo.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Buscar</label>
                    <div className="position-relative">
                      <Search
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                        size={16}
                      />
                      <input
                        type="text"
                        placeholder="Centro de custo ou código..."
                        className="form-control ps-5"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabela de classificação */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-0 p-4">
                <h5 className="fw-semibold mb-0">
                  Classificação de Centros de Custo
                  {(filterType !== "TODOS" && filterType !== "") ||
                  searchTerm !== "" ? (
                    <span className="text-muted fs-6 ms-2">
                      ({filteredRHData.length} de {rhData.length} itens)
                    </span>
                  ) : null}
                </h5>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="border-0 py-3">Status</th>
                        <th className="border-0 py-3">Filial</th>
                        <th className="border-0 py-3">Código</th>
                        <th className="border-0 py-3">Centro de Custo</th>
                        <th className="border-0 py-3">Valor Líquido</th>
                        <th className="border-0 py-3">Tipo de Rateio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRHData.length > 0 ? (
                        filteredRHData.map((item, index) => {
                          const tipoRateioObj = tiposRateio.find(
                            (t) => String(t.value) === String(item.tipoRateio)
                          );
                          return (
                            <tr
                              key={`rh-${item.id || index}`}
                              className="align-middle"
                            >
                              <td className="px-4">
                                {getStatusIcon(item.status)}
                              </td>
                              <td className="px-4">
                                <span className="badge bg-light text-dark">
                                  {item.filial}
                                </span>
                              </td>
                              <td className="px-4">
                                <code className="bg-light px-2 py-1 rounded">
                                  {item.codigo}
                                </code>
                              </td>
                              <td className="px-4">
                                <div>
                                  <span className="fw-semibold">
                                    {item.centroCusto}
                                  </span>
                                  <br />
                                  <small className="text-muted">
                                    {item.tipoCusto}
                                  </small>
                                </div>
                              </td>
                              <td className="px-4">
                                <span className="fw-bold text-info">
                                  {formatCurrency(item.vlrLiquido)}
                                </span>
                              </td>
                              <td className="px-4">
                                <select
                                  className="form-select form-select-sm"
                                  value={item.tipoRateio}
                                  onChange={async (e) => {
                                    const newTipoRateio = e.target.value;
                                    console.log(
                                      `🔄 RH: Alterando item ${item.centroCusto} para tipo ${newTipoRateio}`
                                    );

                                    const updatedData = rhData.map((rh) =>
                                      rh.centroCusto === item.centroCusto
                                        ? { ...rh, tipoRateio: newTipoRateio }
                                        : rh
                                    );
                                    setrhData(updatedData);

                                    try {
                                      const resultado = await MaquinaRateiRH(
                                        item.codigo,
                                        newTipoRateio,
                                        item.filial
                                      );
                                      if (resultado.success) {
                                        console.log(
                                          "✅ RH: Tipo rateio salvo com sucesso"
                                        );
                                      } else {
                                        console.error(
                                          "❌ RH: Erro ao salvar:",
                                          resultado.message
                                        );
                                      }
                                    } catch (error) {
                                      console.error(
                                        "❌ RH: Erro na chamada da API:",
                                        error
                                      );
                                    }
                                  }}
                                >
                                  {tiposRateio.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>
                                      {tipo.label}
                                    </option>
                                  ))}
                                </select>
                                {tipoRateioObj && (
                                  <div className="mt-1">
                                    <span
                                      className={`badge bg-${
                                        tipoRateioObj.color || "secondary"
                                      } bg-opacity-10 text-${
                                        tipoRateioObj.color || "secondary"
                                      } small`}
                                    >
                                      {tipoRateioObj.label}
                                    </span>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center py-4 text-muted"
                          >
                            <div className="d-flex flex-column align-items-center">
                              <AlertCircle
                                size={48}
                                className="text-muted mb-2"
                              />
                              <p className="mb-0">
                                Nenhum item encontrado com os filtros aplicados
                              </p>
                              <small>Tente alterar os critérios de busca</small>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderReceitas = () => {
    // ✅ SOMA SEM REPETIR CENTRO DE CUSTO
    const filteredTotal = (() => {
      const uniqueCenters = new Map();

      filteredEduData.forEach((item) => {
        if (!uniqueCenters.has(item.centroCusto)) {
          // Primeira ocorrência do centro - adiciona o valor
          uniqueCenters.set(item.centroCusto, item.vlrLiquido);
        }
        // Se quiser SOMAR todas as ocorrências do mesmo centro:
        // else {
        //   uniqueCenters.set(item.centroCusto, uniqueCenters.get(item.centroCusto) + item.vlrLiquido);
        // }
      });

      return Array.from(uniqueCenters.values()).reduce(
        (sum, value) => sum + value,
        0
      );
    })();


    // ✅ DEBUG - para verificar se está funcionando
    console.log(`📊 Total registros: ${filteredEduData.length}`);
    console.log(
      `🏢 Centros únicos: ${
        new Set(filteredEduData.map((i) => i.centroCusto)).size
      }`
    );
    console.log(
      `💰 Soma com duplicatas: ${filteredEduData.reduce(
        (sum, item) => sum + item.vlrLiquido,
        0
      )}`
    );
    console.log(`💎 Soma sem duplicatas: ${filteredTotal}`);

    return (
      <div className="container-fluid">
        {/* Header com métricas */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="d-flex align-items-center">
                      <div className="p-3 bg-success bg-opacity-10 rounded-3 me-3">
                        <TrendingUp className="text-success" size={24} />
                      </div>
                      <div>
                        <h4 className="fw-bold mb-1 text-success">
                          RATEIO RECEITAS EDUCACIONAIS
                        </h4>
                        <p className="text-muted mb-0">
                          Classificação de centros de custo únicos
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 text-md-end">
                    <div className="row g-3">
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">
                            Total Único{" "}
                            {filterType !== "TODOS" && filterType !== ""
                              ? "Filtrado"
                              : "Geral"}
                          </small>
                          <h5 className="fw-bold mb-0 text-success">
                            {formatCurrency(filteredTotal)}
                          </h5>
                          <small className="text-muted">
                            {
                              new Set(filteredEduData.map((i) => i.centroCusto))
                                .size
                            }{" "}
                            centros únicos
                          </small>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="bg-light rounded p-3 text-center">
                          <small className="text-muted d-block">
                            Registros
                          </small>
                          <h5 className="fw-bold mb-0">
                            {filteredEduData.length}
                          </h5>
                          <small className="text-muted">Total de itens</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="row g-3 align-items-center">
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">
                      Tipo de Rateio
                    </label>
                    <select
                      disabled
                      className="form-select"
                      value={filterType}
                      onChange={(e) => setFilterType(e.target.value)}
                    >
                      <option value="TODOS">TODOS</option>
                      {tiposRateio.map((tipo, index) => (
                        <option
                          key={`filter-${tipo.value}-${index}`}
                          value={tipo.value}
                        >
                          {tipo.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label fw-semibold">Buscar</label>
                    <div className="position-relative">
                      <Search
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                        size={16}
                      />
                      <input
                        type="text"
                        placeholder="Centro de custo ou código..."
                        className="form-control ps-5"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabela de classificação */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-transparent border-0 p-4">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="fw-semibold mb-0">
                    Classificação de Centros de Custo
                    {(filterType !== "TODOS" && filterType !== "") ||
                    searchTerm !== "" ? (
                      <span className="text-muted fs-6 ms-2">
                        ({filteredEduData.length} registros |{" "}
                        {
                          new Set(filteredEduData.map((i) => i.centroCusto))
                            .size
                        }{" "}
                        únicos)
                      </span>
                    ) : null}
                  </h5>
                  <small className="text-muted">
                    💡 Soma considera apenas centros únicos
                  </small>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="border-0 py-3">Status</th>
                        <th className="border-0 py-3">Filial</th>
                        <th className="border-0 py-3">Código</th>
                        <th className="border-0 py-3">Centro de Custo</th>
                        <th className="border-0 py-3">Valor Líquido</th>
                        <th className="border-0 py-3">Tipo de Rateio</th>
                        <th className="border-0 py-3">Rateio</th>
                        <th className="border-0 py-3">Valores</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredEduData.length > 0 ? (
                        filteredEduData.map((item, index) => {
                          const tipoRateioObj = tiposRateio.find(
                            (t) => String(t.value) === String(item.tipoRateio)
                          );

                          // ✅ Indica se é uma duplicata
                          const isDuplicate =
                            filteredEduData.findIndex(
                              (i) => i.centroCusto === item.centroCusto
                            ) !== index;

                          return (
                            <tr
                              key={`receita-${item.id || index}`}
                              className={`align-middle ${
                                isDuplicate ? "table-warning" : ""
                              }`}
                            >
                              <td className="px-4">
                                <div className="d-flex align-items-center gap-1">
                                  {getStatusIcon(item.status)}
                                  {isDuplicate && (
                                    <span
                                      className="badge bg-warning text-dark"
                                      title="Centro duplicado - não soma no total"
                                    >
                                      + TIPO
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="px-4">
                                <span className="badge bg-light text-dark">
                                  {item.filial}
                                </span>
                              </td>
                              <td className="px-4">
                                <code className="bg-light px-2 py-1 rounded">
                                  {item.codigo}
                                </code>
                              </td>
                              <td className="px-4">
                                <div>
                                  <span className="fw-semibold">
                                    {item.centroCusto}
                                  </span>
                                  <br />
                                  <small className="text-muted">
                                    {item.tipoCusto}
                                  </small>
                                </div>
                              </td>
                              <td className="px-4">
                                <span
                                  className={`fw-bold ${
                                    isDuplicate ? "text-muted" : "text-success"
                                  }`}
                                >
                                  {formatCurrency(item.vlrLiquido)}
                                </span>
                              </td>
                              <td className="px-4">
                                {tipoRateioObj && (
                                  <div className="mt-1">
                                    <span
                                      className={`badge bg-${
                                        tipoRateioObj.color || "secondary"
                                      } bg-opacity-10 text-${
                                        tipoRateioObj.color || "secondary"
                                      } small`}
                                    >
                                      {tipoRateioObj.label}
                                    </span>
                                  </div>
                                )}
                              </td>

                              <td className="px-4">
                                <select
                                  className="form-select form-select-sm"
                                  value={item.rateio}
                                  onChange={async (e) => {
                                    const newRateio = e.target.value;
                                    console.log(
                                      `🔄 EDU: Alterando RATEIO do item ${item.centroCusto} para ${newRateio}`
                                    );

                                    const updatedData = receitasData.map(
                                      (receita) =>
                                        receita.id === item.id
                                          ? { ...receita, rateio: newRateio }
                                          : receita
                                    );
                                    setreceitasData(updatedData);

                                    try {
                                      const resultado = await MaquinaRateioEDU(
                                        item.codigo,
                                        item.tipoRateio,
                                        newRateio,
                                        item.valores,
                                        item.filial
                                      );
                                      if (resultado.success) {
                                        console.log(
                                          "✅ EDU: Rateio salvo com sucesso"
                                        );
                                      } else {
                                        console.error(
                                          "❌ EDU: Erro ao salvar rateio:",
                                          resultado.message
                                        );
                                      }
                                    } catch (error) {
                                      console.error(
                                        "❌ EDU: Erro na chamada da API rateio:",
                                        error
                                      );
                                    }
                                  }}
                                >
                                  {Rateio.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>
                                      {tipo.label}
                                    </option>
                                  ))}
                                </select>
                              </td>

                              <td className="px-4">
                                <select
                                  className="form-select form-select-sm"
                                  value={item.valores}
                                  onChange={async (e) => {
                                    const newValores = e.target.value;
                                    console.log(
                                      `🔄 EDU: Alterando VALORES do item ${item.centroCusto} para ${newValores}`
                                    );

                                    const updatedData = receitasData.map(
                                      (receita) =>
                                        receita.id === item.id
                                          ? { ...receita, valores: newValores }
                                          : receita
                                    );
                                    setreceitasData(updatedData);

                                    try {
                                      const resultado = await MaquinaRateioEDU(
                                        item.codigo,
                                        item.tipoRateio,
                                        item.rateio,
                                        newValores,
                                        item.filial
                                      );
                                      if (resultado.success) {
                                        console.log(
                                          "✅ EDU: Valores salvos com sucesso"
                                        );
                                      } else {
                                        console.error(
                                          "❌ EDU: Erro ao salvar valores:",
                                          resultado.message
                                        );
                                      }
                                    } catch (error) {
                                      console.error(
                                        "❌ EDU: Erro na chamada da API valores:",
                                        error
                                      );
                                    }
                                  }}
                                >
                                  {valores.map((tipo) => (
                                    <option key={tipo.value} value={tipo.value}>
                                      {tipo.label}
                                    </option>
                                  ))}
                                </select>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="8"
                            className="text-center py-4 text-muted"
                          >
                            <div className="d-flex flex-column align-items-center">
                              <AlertCircle
                                size={48}
                                className="text-muted mb-2"
                              />
                              <p className="mb-0">
                                Nenhum item encontrado com os filtros aplicados
                              </p>
                              <small>Tente alterar os critérios de busca</small>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // ✅ RENDERDASBOARD AJUSTADO COM DADOS REAIS ÚNICOS
  const renderDashboard = () => {
    // Calcular totais únicos para cada categoria
    const despesasTotal = calculateUniqueTotal(despesasData);
    const investimentosTotal = calculateUniqueTotal(investimentosData);
    const rhTotal = calculateUniqueTotal(rhData);
    const receitasTotal = calculateUniqueTotal(receitasData);
    const receitaDivTotal = calculateUniqueTotal(ReceitaDivData);

    // Total geral (soma de todos os únicos)
    const totalGeral =
      receitasTotal +
      receitaDivTotal -
      (despesasTotal + investimentosTotal + rhTotal);

    // Contar centros únicos por categoria
    const despesasUnicos = getUniqueCentersCount(despesasData);
    const investimentosUnicos = getUniqueCentersCount(investimentosData);
    const rhUnicos = getUniqueCentersCount(rhData);
    const receitasUnicos = getUniqueCentersCount(receitasData);
    const receitaDivUnicos = getUniqueCentersCount(ReceitaDivData);

    // Configurados únicos
    const despesasConfigurados = getUniqueConfiguredCount(despesasData);
    const investimentosConfigurados =
      getUniqueConfiguredCount(investimentosData);
    const rhConfigurados = getUniqueConfiguredCount(rhData);
    const receitasConfigurados = getUniqueConfiguredCount(receitasData);
    const receitaDivConfigurados = getUniqueConfiguredCount(ReceitaDivData);

    return (
      <div className="container-fluid">
        {/* Resumo geral */}
        <div className="row g-4 mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm bg-gradient-primary text-white">
              <div className="card-body p-4">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <h3 className="fw-bold mb-2">
                      Sistema de Classificação de Centros de Custo
                    </h3>
                    <p className="mb-0 opacity-75">
                      Gerencie e classifique os rateios de despesas,
                      investimentos e recursos humanos (valores únicos por
                      centro)
                    </p>
                  </div>
                  <div className="col-md-4 text-md-end">
                    <div className="d-flex justify-content-end gap-3">
                      <div className="text-center">
                        <h4 className="fw-bold mb-1">
                          {formatCurrency(totalGeral)}
                        </h4>
                        <small className="opacity-75">Total Único</small>
                        <div className="mt-1">
                          <small className="opacity-60">
                            {despesasUnicos +
                              investimentosUnicos +
                              rhUnicos +
                              receitasUnicos +
                              receitaDivUnicos}{" "}
                            centros únicos
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Cards principais */}
        <div className="row g-4 mb-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="p-3 bg-danger bg-opacity-10 rounded-3">
                    <DollarSign className="text-danger" size={32} />
                  </div>
                  <span className="badge bg-light text-muted">
                    {despesasConfigurados}/{despesasUnicos}
                  </span>
                </div>
                <h5 className="fw-semibold mb-2">Despesas</h5>
                <h4 className="fw-bold text-danger mb-2">
                  {formatCurrency(despesasTotal)}
                </h4>
                <p className="text-muted small mb-3">
                  {despesasUnicos} centros únicos • {despesasData.length}{" "}
                  registros
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-success">
                    ✓ {despesasConfigurados} configurados
                  </small>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    onClick={() => setActiveSection("despesas")}
                  >
                    Gerenciar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="p-3 bg-primary bg-opacity-10 rounded-3">
                    <BarChart3 className="text-primary" size={32} />
                  </div>
                  <span className="badge bg-light text-muted">
                    {investimentosConfigurados}/{investimentosUnicos}
                  </span>
                </div>
                <h5 className="fw-semibold mb-2">Investimentos</h5>
                <h4 className="fw-bold text-primary mb-2">
                  {formatCurrency(investimentosTotal)}
                </h4>
                <p className="text-muted small mb-3">
                  {investimentosUnicos} centros únicos •{" "}
                  {investimentosData.length} registros
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-success">
                    ✓ {investimentosConfigurados} configurados
                  </small>
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => setActiveSection("investimentos")}
                  >
                    Gerenciar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="p-3 bg-info bg-opacity-10 rounded-3">
                    <Users className="text-info" size={32} />
                  </div>
                  <span className="badge bg-light text-muted">
                    {rhConfigurados}/{rhUnicos}
                  </span>
                </div>
                <h5 className="fw-semibold mb-2">Recursos Humanos</h5>
                <h4 className="fw-bold text-info mb-2">
                  {formatCurrency(rhTotal)}
                </h4>
                <p className="text-muted small mb-3">
                  {rhUnicos} centros únicos • {rhData.length} registros
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-success">
                    ✓ {rhConfigurados} configurados
                  </small>
                  <button
                    className="btn btn-outline-info btn-sm"
                    onClick={() => setActiveSection("rh")}
                  >
                    Gerenciar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="p-3 bg-success bg-opacity-10 rounded-3">
                    <TrendingUp className="text-success" size={32} />
                  </div>
                  <span className="badge bg-light text-muted">
                    {receitasConfigurados}/{receitasUnicos}
                  </span>
                </div>
                <h5 className="fw-semibold mb-2">Rec. Educacionais</h5>
                <h4 className="fw-bold text-success mb-2">
                  {formatCurrency(receitasTotal)}
                </h4>
                <p className="text-muted small mb-3">
                  {receitasUnicos} centros únicos • {receitasData.length}{" "}
                  registros
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-success">
                    ✓ {receitasConfigurados} configurados
                  </small>
                  <button
                    className="btn btn-outline-success btn-sm"
                    onClick={() => setActiveSection("receitas")}
                  >
                    Gerenciar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card adicional para Receitas Diversas */}
        <div className="row g-4 mb-4">
          <div className="col-md-4">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="p-3 bg-warning bg-opacity-10 rounded-3">
                    <TrendingUp className="text-warning" size={24} />
                  </div>
                  <span className="badge bg-light text-muted">
                    {receitaDivConfigurados}/{receitaDivUnicos}
                  </span>
                </div>
                <h6 className="fw-semibold mb-2">Receitas Diversas</h6>
                <h5 className="fw-bold text-warning mb-2">
                  {formatCurrency(receitaDivTotal)}
                </h5>
                <p className="text-muted small mb-3">
                  {receitaDivUnicos} centros únicos • {ReceitaDivData.length}{" "}
                  registros
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-success">
                    ✓ {receitaDivConfigurados} configurados
                  </small>
                  <button
                    className="btn btn-outline-warning btn-sm"
                    onClick={() => setActiveSection("ReceitaDiversas")}
                  >
                    Gerenciar
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Resumo de Performance */}
          <div className="col-md-8">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-4">
                <h6 className="fw-semibold mb-3">📊 Resumo de Performance</h6>
                <div className="row g-3">
                  <div className="col-3">
                    <div className="text-center p-2 bg-light rounded">
                      <h6 className="fw-bold mb-0 text-danger">
                        {despesasUnicos}
                      </h6>
                      <small className="text-muted">Despesas</small>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="text-center p-2 bg-light rounded">
                      <h6 className="fw-bold mb-0 text-primary">
                        {investimentosUnicos}
                      </h6>
                      <small className="text-muted">Investimentos</small>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="text-center p-2 bg-light rounded">
                      <h6 className="fw-bold mb-0 text-info">{rhUnicos}</h6>
                      <small className="text-muted">RH</small>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="text-center p-2 bg-light rounded">
                      <h6 className="fw-bold mb-0 text-success">
                        {receitasUnicos}
                      </h6>
                      <small className="text-muted">Receitas</small>
                    </div>
                  </div>
                </div>
                <div className="mt-3 text-center">
                  <small className="text-muted">
                    💡 Valores únicos por centro de custo • Total:{" "}
                    {despesasUnicos +
                      investimentosUnicos +
                      rhUnicos +
                      receitasUnicos +
                      receitaDivUnicos}{" "}
                    centros
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Estatísticas de progresso */}
      </div>
    );
  };

  const renderResultado = () => (
    <div className="container-fluid">
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="d-flex align-items-center">
                    <div className="p-3 bg-secondary bg-opacity-10 rounded-3 me-3">
                      <span className="fs-2">🧮</span>
                    </div>
                    <div>
                      <h4 className="fw-bold mb-1 text-secondary">
                        RESULTADO SINTÉTICO
                      </h4>
                      <p className="text-muted mb-0">
                        Relatório consolidado dos rateios processados
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 text-md-end">
                  <div className="d-flex gap-2 justify-content-md-end">
                    <button className="btn btn-primary">
                      🧮 Calcular Rateio
                    </button>
                    <button className="btn btn-success">📊 Excel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-primary text-white border-0 p-4">
              <h5 className="fw-bold mb-1">RATEIO MÃO DE OBRA INDIRETA CND</h5>
              <small className="opacity-75">
                TOTAL GERAL RATEIO: R$ 12.301.490,24
              </small>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="border-0 py-3">Filial</th>
                      <th className="border-0 py-3">Código</th>
                      <th className="border-0 py-3">Centro de Custo</th>
                      <th className="border-0 py-3">Percentual</th>
                      <th className="border-0 py-3">Vlr Rateio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="px-4">1</td>
                      <td className="px-4">
                        <code>1.05.01.03.002</code>
                      </td>
                      <td className="px-4">
                        Integral/Bilíngue - Fundamental I
                      </td>
                      <td className="px-4">
                        <span className="badge bg-info">3.22%</span>
                      </td>
                      <td className="px-4">
                        <strong>R$ 396.107,99</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4">1</td>
                      <td className="px-4">
                        <code>1.05.01.03.003</code>
                      </td>
                      <td className="px-4">Middle School</td>
                      <td className="px-4">
                        <span className="badge bg-info">2.28%</span>
                      </td>
                      <td className="px-4">
                        <strong>R$ 280.473,98</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4">1</td>
                      <td className="px-4">
                        <code>1.05.01.02.002</code>
                      </td>
                      <td className="px-4">Ensino Fundamental I</td>
                      <td className="px-4">
                        <span className="badge bg-info">27.04%</span>
                      </td>
                      <td className="px-4">
                        <strong>R$ 3.326.322,96</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4">1</td>
                      <td className="px-4">
                        <code>1.05.01.02.003</code>
                      </td>
                      <td className="px-4">Ensino Fundamental II</td>
                      <td className="px-4">
                        <span className="badge bg-info">32.33%</span>
                      </td>
                      <td className="px-4">
                        <strong>R$ 3.977.071,79</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4">1</td>
                      <td className="px-4">
                        <code>1.05.01.02.004</code>
                      </td>
                      <td className="px-4">Ensino Médio</td>
                      <td className="px-4">
                        <span className="badge bg-info">20.15%</span>
                      </td>
                      <td className="px-4">
                        <strong>R$ 2.478.750,28</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-danger text-white border-0 p-4">
              <h5 className="fw-bold mb-1">RATEIO DESPESAS INDIRETO CND</h5>
              <small className="opacity-75">
                TOTAL GERAL RATEIO: R$ 18.330.209,40
              </small>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="border-0 py-3">Filial</th>
                      <th className="border-0 py-3">Código</th>
                      <th className="border-0 py-3">Centro de Custo</th>
                      <th className="border-0 py-3">Percentual</th>
                      <th className="border-0 py-3">Vlr Rateio</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="px-4">1</td>
                      <td className="px-4">
                        <code>1.05.01.02.002</code>
                      </td>
                      <td className="px-4">Ensino Fundamental I</td>
                      <td className="px-4">
                        <span className="badge bg-warning">26.29%</span>
                      </td>
                      <td className="px-4">
                        <strong>R$ 4.819.012,05</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4">1</td>
                      <td className="px-4">
                        <code>1.05.01.02.003</code>
                      </td>
                      <td className="px-4">Ensino Fundamental II</td>
                      <td className="px-4">
                        <span className="badge bg-warning">31.43%</span>
                      </td>
                      <td className="px-4">
                        <strong>R$ 5.761.184,81</strong>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4">1</td>
                      <td className="px-4">
                        <code>1.05.01.02.004</code>
                      </td>
                      <td className="px-4">Ensino Médio</td>
                      <td className="px-4">
                        <span className="badge bg-warning">19.59%</span>
                      </td>
                      <td className="px-4">
                        <strong>R$ 3.590.888,02</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm bg-dark text-white">
            <div className="card-body p-4">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <h4 className="fw-bold mb-2">
                    🧮 CONSOLIDADO GERAL DO SISTEMA
                  </h4>
                  <p className="mb-0 opacity-75">
                    Soma de todos os rateios processados no período
                  </p>
                </div>
                <div className="col-md-6 text-md-end">
                  <h2 className="fw-bold mb-1">R$ 30.631.699,64</h2>
                  <small className="opacity-75">
                    2 categorias de rateio • 8 itens processados
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderContent = () => {
    switch (activeSection) {
      case "dashboard":
        return renderDashboard();
      case "despesas":
        return renderDespesas();
      case "investimentos":
        return renderInvestimentos();
      case "rh":
        return renderRH();
      case "receitas":
        return renderReceitas();
      case "ReceitaDiversas":
        return renderReceitaDiversas();
      default:
        return renderResultado();
    }
  };

  return (
    <>
      <style jsx>{`
        .space-y-3 > * + * {
          margin-top: 0.75rem;
        }
        .bg-gradient-primary {
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
        }
        .card:hover {
          transform: translateY(-2px);
          transition: all 0.2s ease;
        }
        body {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            sans-serif;
        }
      `}</style>

      <div className="d-flex vh-100 bg-light">
        {/* Sidebar */}
        <div
          className="bg-white border-end d-flex flex-column"
          style={{ width: "260px" }}
        >
          <div className="p-4 border-bottom">
            <h4 className="fw-bold mb-0">Maq. de Rateio</h4>
            <small className="text-muted">Classificação</small>
          </div>

          <nav className="flex-grow-1 p-3">
            {menuItems.map((item) => {
              const IconComponent = item.icon;
              const isActive = activeSection === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => setActiveSection(item.id)}
                  className={`btn w-100 d-flex align-items-center text-start p-3 mb-2 border-0 rounded-3 ${
                    isActive
                      ? "btn-primary"
                      : "btn-link text-dark text-decoration-none"
                  }`}
                >
                  <IconComponent size={20} className="me-3" />
                  <span className="fw-medium">{item.titulo}</span>
                </button>
              );
            })}
          </nav>

          <div className="p-3 border-top text-center">
            <small className="text-muted d-block">Sistema de Rateio</small>
            <small className="fw-medium">v3.0</small>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-grow-1 d-flex flex-column">
          <header className="bg-white border-bottom px-4 py-3">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h2 className="fw-semibold mb-1">
                  {menuItems.find((item) => item.id === activeSection)
                    ?.titulo || "Dashboard"}
                </h2>
                <p className="text-muted small mb-0">
                  Sistema de Classificação de Centros de Custo
                </p>
              </div>

              <div className="d-flex align-items-center">
                <button className="btn btn-light me-2">
                  <Settings size={18} />
                </button>
                <button className="btn btn-light">
                  <Download size={18} />
                </button>
              </div>
            </div>
          </header>

          <main className="flex-grow-1 overflow-auto p-4">
            {renderContent()}
          </main>
        </div>
      </div>
    </>
  );
};

export default SistemaClassificacao;
